import { render, staticRenderFns } from "./DataTableInspectionPlan.vue?vue&type=template&id=230bb73a&"
import script from "./DataTableInspectionPlan.vue?vue&type=script&lang=ts&"
export * from "./DataTableInspectionPlan.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableInspectionPlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
